import { COLOR_PRIMARY } from "./index";
export const GRAVATAR_URL = "https://gravatar.com";

export const PASSWORD_RULES = [
    { key: "length", label: "At least 8 characters", test: (value) => value.length >= 8 },
    { key: "case", label: "Upper & lowercase letter", test: (value) => /[a-z]/.test(value) && /[A-Z]/.test(value) },
    { key: "number", label: "At least one number", test: (value) => /\d/.test(value) },
    { key: "special", label: "At least one symbol", test: (value) => /[^A-Za-z0-9]/.test(value) },
];

export const STRENGTH_LEVELS = [
    { label: "Weak", color: "#FF4D4F" },
    { label: "Fair", color: "#FAAD14" },
    { label: "Good", color: COLOR_PRIMARY },
    { label: "Strong", color: "#52C41A" },
];

